export const GET_POKEMONS = 'GET_POKEMONS';
export const GET_POKEMONS_ERROR = 'GET_POKEMONS_ERROR';
export const GET_POKEMON_LOADING = 'GET_POKEMON_LOADING';

export const SET_SELECTED_POKEMON = 'SET_SELECTED_POKEMON';
